import { get, writable } from 'svelte/store';

import type { PageVisibilityStore, PageVisibilityStoreState } from './types';

function createStore(): PageVisibilityStore {
    const initialValue: PageVisibilityStoreState = {
        isHidden: false,
    };
    const store = writable(initialValue);
    const { subscribe, update } = store;
    const updateStore = (data: Partial<PageVisibilityStoreState>) => {
        update((state) => {
            return {
                ...state,
                ...data,
            };
        });
    };

    return {
        subscribe,
        get: () => {
            return get(store);
        },
        setIsHidden: (isHidden: boolean) => {
            updateStore({ isHidden });
        },
    };
}

export const pageVisibilityStore = createStore();

